import { useEffect, useState } from 'react';
import { clientAllocate } from '@fiverr-private/experiments';
import { mixpanel } from '@fiverr-private/obs';
import { Experiments } from '../../../../shared/constants/experiments';
import { useExperiment } from '../../../../shared/hooks/useExperiment';
import { globalMixpanelReporter } from '../../../../events/mixpanel';

const { LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP } = Experiments;

interface Props {
    rolloutResult: boolean;
    mixpanelRecordingsRolloutResult: boolean;
}

export const useDoubleStepResetPasswordExperiment = ({ rolloutResult, mixpanelRecordingsRolloutResult }: Props) => {
    const { group } = useExperiment(LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP);
    const [experimentGroup, setExperimentGroup] = useState(group);

    useEffect(() => {
        if (group) {
            return;
        }

        const allocatedGroup = clientAllocate({
            experimentId: LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP,
            experimentType: 'guest',
            numOfGroups: 2,
            rolloutResult,
        });

        if (allocatedGroup) {
            setExperimentGroup(allocatedGroup);
            globalMixpanelReporter.enrichContext(
                {
                    resetPasswordExperiment: allocatedGroup,
                },
                { preserve: true }
            );
        }
    }, [group, rolloutResult]);

    useEffect(() => {
        if (mixpanelRecordingsRolloutResult && experimentGroup) {
            mixpanel.startSessionRecording();
        }
    }, [mixpanelRecordingsRolloutResult, experimentGroup]);

    return experimentGroup;
};
